var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { LayoutThemeEnum } from 'src/app/layout/models/layout-theme.enum';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { LayoutState } from 'src/app/layout/state/layout.state';
import { Observable, merge, Subject, combineLatest, of, fromEvent } from 'rxjs';
import { EditViewEnum } from '../../models/edit-view.enum';
import { SetView, ShowColumn, ResetEditPage, SetObjectVisibility } from '../../state/edit.actions';
import { EditState } from '../../state/edit.state';
import { EngineState } from 'src/app/engine/state/engine.state';
import { StoryState } from 'src/app/story/state/story.state';
import { filter, delay, map, take, switchMap, takeUntil, flatMap, first } from 'rxjs/operators';
import { LoadStory, SetIncomingStory, BuildStory, LoadStorySuccess, LoadStoryFail, SetStoryText, ImportStorySuccess } from 'src/app/story/state/story.actions';
import { SetEnginePosition, ClickNode, SetActiveTool, SetDisplay, ToggleLabels } from 'src/app/engine/state/engine.actions';
import { EnginePositionModel } from 'src/app/engine/models/engine-position.model';
import { SetTheme } from 'src/app/layout/state/layout.actions';
import { EngineVisibilityEnum } from 'src/app/engine/models/engine-visibility.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { PreviousChapter, NextChapter, DuplicateChapter, RecordChapterVisibilityState, RecordChapterCamera, SelectChapter, LastChapter, RecordChapterPaintState, RemoveChapter, SetChapters, SetChapterBackground, SetAllChaptersBackground } from 'src/app/story/state/chapters/story.chapters.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { MatDialog, MatSnackBar } from '@angular/material';
import { SetCamera, LockCamera } from 'src/app/engine/state/camera/engine.camera.actions';
import { EngineCameraState } from 'src/app/engine/state/camera/engine.camera.state';
import { SaveBookmark, SelectBookmark, SaveBookmarkSuccess, SaveBookmarkFail, SetBookmarkText } from 'src/app/bookmarks/state/bookmarks.actions';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { PublishDialogComponent } from 'src/app/publish/components/publish-dialog/publish-dialog.component';
import { AnimationService } from 'src/app/engine/animation.service';
import { RemoveLabel, EnableContextLabel, ConvertLabels, AddLabel, CopyLabels, RemoveAllLabels, SetLabel } from 'src/app/story/state/labels/story.labels.actions';
import { BookmarksService } from 'src/app/bookmarks/bookmarks.service';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { Location } from '@angular/common';
import { ContentDialogComponent } from '../../components/content-dialog/content-dialog.component';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { Undo, Redo, ResetHistory } from 'src/app/history/state/history.actions';
import { HistoryService } from 'src/app/history/history.service';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { SetCheckedNodes, ToggleVisibleNodes, CheckNode, SelectNode, ExpandNode, ResetEngineNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { ToolIcons } from 'src/app/engine/models/tool-icons.const';
import * as Mousetrap from 'mousetrap';
import { DialogService } from 'src/app/dialogs/dialog.service';
import { LabelRecipe } from 'src/app/story/models/labels/label-recipe.enum';
import { environment } from 'src/environments/environment';
import { LabelThemeEnum } from 'src/app/story/models/labels/label-theme.enum';
import { SaveModuleSuccess } from 'src/app/modules/state/modules.actions';
import { StoryLoadTypeEnum } from 'src/app/story/models/story-load-type.enum';
import { GraphUtils } from 'src/lib/graph/graph-utils';
import { UserMessageEnum } from 'src/app/auth/models/user-message-model';
import { SetUserMessageViewed, GetUserMessage, GetUserMessageSuccess, LogoutSuccess } from 'src/app/auth/state/auth/auth.actions';
import { StoryService } from 'src/app/story/story.service';
var EditComponent = /** @class */ (function () {
    function EditComponent(actions, activatedRoute, router, animationService, bookmarkService, historyService, dialog, dialogService, graphService, location, snackBar, store, storyService, snackbar) {
        this.actions = actions;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.animationService = animationService;
        this.bookmarkService = bookmarkService;
        this.historyService = historyService;
        this.dialog = dialog;
        this.dialogService = dialogService;
        this.graphService = graphService;
        this.location = location;
        this.snackBar = snackBar;
        this.store = store;
        this.storyService = storyService;
        this.snackbar = snackbar;
        // Local declarations so we can use them in the template
        this.layoutThemeEnum = LayoutThemeEnum;
        this.editViewEnum = EditViewEnum;
        this.toolEnum = ToolEnum;
        this.toolIcons = ToolIcons;
        this.exportType = environment.exportType; // 'module' or 'bookmark'
        // track changes: requiring save
        this.isStoryDirty = false;
        this.ngUnsubscribe = new Subject();
        this.isAnimated = false;
        this.atBookmarkLimit = false;
    }
    EditComponent.prototype.ngOnInit = function () {
        var id = this.activatedRoute.snapshot.queryParams.id;
        this.id = this.sanitizeRouteId(id);
        this.type = this.storyService.getStoryType(this.id);
        this.store.dispatch(new SetTheme(LayoutThemeEnum.Dark));
        this.store.dispatch(new SetActiveTool(ToolEnum.Select));
        this.store.dispatch(new ResetEditPage());
        this.store.dispatch(new SetDisplay(true));
        this.store.dispatch(new ToggleLabels(true));
        this.store.dispatch(new LockCamera(true));
        this.store.dispatch(new EnableContextLabel(false));
        this.store.dispatch(new SetIncomingStory(this.id, this.type));
        // set story metadata
        this.store.dispatch(new SelectBookmark(this.id, this.type));
        this.resizeEngineContainer();
        this.initListeners();
        this.initAuthChecks();
        this.initKeyboardListeners();
        this.initDirtyCheck();
    };
    EditComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () { return _this.resizeEngineContainer(); }, 0);
    };
    EditComponent.prototype.ngOnDestroy = function () {
        // #TODO: Put theme management in route
        // Change the theme
        this.store.dispatch(new SetTheme(LayoutThemeEnum.Light));
        this.store.dispatch(new SetDisplay(false));
        this.store.dispatch(new ResetEngineNodes());
        this.store.dispatch(new EnableContextLabel(false));
        this.unbindKeyboardListeners();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    // confirm if save needed before exiting
    EditComponent.prototype.canDeactivate = function () {
        var _this = this;
        // validate session
        var profile = this.store.selectSnapshot(AuthState.getUserProfile);
        if (profile && this.isStoryDirty) { // ask save before exiting
            var bookmark_1 = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
            var bookmarkTitle_1 = this.store.selectSnapshot(StoryState.getStory).displayName;
            var saveType_1 = this.getBookmarkSaveType(bookmark_1);
            return this.confirmSaveDialog(true) // confirm + save (optionally)
                .pipe(flatMap(function (confirmSave) {
                if (typeof (confirmSave) === 'undefined') { // navigation: cancel
                    return of(false);
                }
                else if (confirmSave) { // navigation: save + leave
                    var savedBookmark$ = saveType_1 === 'save' ? _this.saveBookmark(bookmark_1, true) : _this.saveNewBookmarkDialog('Save As', bookmarkTitle_1);
                    return savedBookmark$
                        .pipe(map(function () { return true; }));
                }
                else { // navigation: leave
                    return of(true);
                }
            }), takeUntil(this.ngUnsubscribe));
        }
        else { // exit as normal
            return of(true);
        }
    };
    EditComponent.prototype.resizeEngineContainer = function () {
        var _a = this.engineContainer.nativeElement, offsetLeft = _a.offsetLeft, offsetTop = _a.offsetTop, offsetWidth = _a.offsetWidth, offsetHeight = _a.offsetHeight;
        var position = new EnginePositionModel(offsetLeft, offsetTop, offsetWidth, offsetHeight, EngineVisibilityEnum.Shown);
        this.store.dispatch(new SetEnginePosition(position));
    };
    /**
     * Listeners
     */
    EditComponent.prototype.initListeners = function () {
        var _this = this;
        this.windowResize$ = fromEvent(window, 'resize');
        combineLatest(this.engineReady$, this.incoming$).pipe(filter(function (_a) {
            var _b = __read(_a, 2), ready = _b[0], incoming = _b[1];
            return ready && !!incoming.id;
        }), takeUntil(this.ngUnsubscribe)).subscribe(function () {
            _this.store.dispatch(new SelectChapter()); // null chapter state
            _this.loadStory();
        });
        // Showing colulmns has changed, let the 3D canvas know
        // Pipe through a delay so that element in window has a chance to redraw
        merge(this.showLeftColumn$, this.showRightColumn$, this.showHeader$, this.showFooter$, this.windowResize$)
            .pipe(delay(10), takeUntil(this.ngUnsubscribe)).subscribe(function () {
            _this.resizeEngineContainer();
        });
        // Listen for changes to record state
        this.record$.subscribe(function (record) {
            _this.record = record;
        });
        // Listen for different chapter. Use id explicitly, because changes to chapter can occur within a chapter.
        this.selectedChapterId$
            .pipe(filter(function (chapter) { return chapter != null; }), map(function (_) { return _this.store.selectSnapshot(StoryChaptersState.getSelectedChapter); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (chapter) {
            _this.handleChapterChange(chapter);
        });
        // Listen for selected label
        this.selectedLabel$
            .pipe(filter(function (label) { return label != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new SetActiveTool(ToolEnum.Label));
            _this.store.dispatch(new SetView(EditViewEnum.Label));
        });
        // Convert annotation labels to StudioNext labels, to push users towards a newer style when using human studio.
        if (this.type === StoryType.Module) {
            this.labels$
                .pipe(filter(function (labels) { return labels.length > 0; }), filter(function () { return environment.exportType === 'bookmark'; }), take(1), takeUntil(this.ngUnsubscribe))
                .subscribe(function (labels) {
                setTimeout(function () {
                    // In the case of internal, labels may have been converted already. Apply this filter to ensure we only
                    // convert labels that are not the StudioNext style.
                    labels = labels.filter(function (label) {
                        return label.theme !== LabelThemeEnum.StudioNext;
                    });
                    _this.store.dispatch(new ConvertLabels(labels, LabelRecipe.StudioNext));
                });
            });
        }
        // Listen for actions
        this.actions
            .pipe(ofActionDispatched(ClickNode), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.handleNodeClick(action.node, action.event);
        });
        this.actions
            .pipe(ofActionDispatched(SaveBookmarkSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) { return _this.handleSaveBookmarkSuccess(action); });
        this.actions
            .pipe(ofActionDispatched(SaveBookmarkFail), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) { return _this.handleSaveBookmarkFailure(action); });
        this.actions
            .pipe(ofActionDispatched(SaveModuleSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) { return _this.handleSaveModuleSuccess(action); });
        this.actions
            .pipe(ofActionDispatched(DuplicateChapter), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            setTimeout(function () {
                _this.store.dispatch(new LastChapter());
            });
        });
        this.actions
            .pipe(ofActionDispatched(ToggleVisibleNodes), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            // Record with current chapter
            var record = _this.store.selectSnapshot(EditState.getRecord);
            _this.store.dispatch(new RecordChapterVisibilityState(action.nodes, action.visible, record));
            if (action.recordHistory) {
                _this.historyService.recordViewGraphHistory();
            }
        });
        // content not found
        this.actions
            .pipe(ofActionDispatched(LoadStoryFail), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new SetIncomingStory(null, null));
            _this.router.navigate(['/404'], {
                queryParams: {
                    errorType: 'content',
                    errorUrl: _this.router.url
                },
                replaceUrl: true
            });
        });
        // NPS survey
        this.actions
            .pipe(ofActionDispatched(SaveBookmarkSuccess), take(1), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new GetUserMessage(UserMessageEnum.SurveyMonkey, 'nps_v4'));
        });
        this.actions
            .pipe(ofActionDispatched(GetUserMessageSuccess), filter(function (event) { return event.message.messageType === UserMessageEnum.SurveyMonkey; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (event) {
            var _a = event.message, showUserAlert = _a.showUserAlert, messageData = _a.messageData, messageSeenId = _a.messageSeenId;
            if (showUserAlert && messageData) {
                _this.store.dispatch(new SetUserMessageViewed(messageSeenId));
                _this.dialogService.openNpsSurveyDialog(messageData);
            }
        });
        // Listen for story import
        this.actions
            .pipe(ofActionDispatched(ImportStorySuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.snackbar.open("Successfully imported " + action.story.displayName + ".");
        });
    };
    // #TODO: [EM] #SceneEditorTouchpoint - assumes bookmark  service authorizes editability
    EditComponent.prototype.initAuthChecks = function () {
        var _this = this;
        // Listen to bookmark loaded, check for access
        this.selectedBookmark$
            .pipe(filter(function (_) { return _this.type === 'module'; }), filter(function (bookmark) { return bookmark != null; }), take(1), takeUntil(this.ngUnsubscribe))
            .subscribe(function (bookmark) {
            if (_this.type === StoryType.Bookmark && !_this.bookmarkService.canEdit(bookmark)) {
                _this.openBookmarkAccessDialog();
            }
        });
        // validate bookmark limit if cannot overwrite selected bookmark
        this.selectedBookmark$
            .pipe(filter(function (selectedBookmark) { return !!selectedBookmark; }), filter(function (selectedBookmark) { return !_this.isBookmarkEditable(selectedBookmark); }), switchMap(function () {
            var profile = _this.store.selectSnapshot(AuthState.getUserProfile);
            if (profile && profile.premium_account_valid) {
                return of(false);
            }
            else {
                return _this.bookmarkService.atMaxFreeBookmarkCount();
            }
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (hasExceeded) {
            _this.handleBookmarkLimit(hasExceeded);
        });
        // validate can view premium content
        this.selectedBookmark$
            .pipe(filter(function (selectedBookmark) { return !!selectedBookmark; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.handlePremiumContent();
        });
    };
    EditComponent.prototype.initDirtyCheck = function () {
        var _this = this;
        // mark not modified
        this.actions
            .pipe(ofActionDispatched(LoadStorySuccess, SaveBookmarkSuccess, LogoutSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.isStoryDirty = false;
        });
        // mark modified
        this.actions
            .pipe(ofActionDispatched(
        // node selections
        ToggleVisibleNodes, RecordChapterCamera, RecordChapterPaintState, RecordChapterVisibilityState, 
        // labels
        AddLabel, RemoveLabel, RemoveAllLabels, CopyLabels, SetLabel, 
        // chapters
        DuplicateChapter, RemoveChapter, ImportStorySuccess, 
        // info text
        SetBookmarkText, SetStoryText, SetChapterBackground, SetAllChaptersBackground), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.isStoryDirty = true;
        });
        // special case: editing chapter info after loaded
        this.actions.pipe(ofActionDispatched(SetChapters))
            .pipe(filter(function () { return _this.store.selectSnapshot(StoryChaptersState.getAllChaptersReady); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.isStoryDirty = true;
        });
    };
    EditComponent.prototype.handleBookmarkLimit = function (exceeded) {
        var _this = this;
        this.atBookmarkLimit = exceeded;
        var profile = this.store.selectSnapshot(AuthState.getUserProfile);
        var bookmark = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
        if (profile && bookmark) {
            var isPremiumUser = profile.premium_account_valid;
            var isBookmarkEditable = this.isBookmarkEditable(bookmark);
            // bookmark limit
            if (exceeded && !isBookmarkEditable && !isPremiumUser) {
                var dialog$ = this.dialogService.openLimitDialog();
                dialog$.afterClosed()
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(function (result) {
                    if (result) {
                        _this.dialogService.openUpgradeDialog();
                    }
                });
            }
        }
    };
    EditComponent.prototype.handlePremiumContent = function () {
        var _this = this;
        var profile = this.store.selectSnapshot(AuthState.getUserProfile);
        var bookmark = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
        if (profile && bookmark) {
            if (bookmark.premium && !profile.premium_account_valid) {
                var dialogRef = this.dialogService.openPremiumContentDialog();
                dialogRef.afterClosed()
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(function (confirmed) {
                    if (confirmed) {
                        _this.dialogService.openUpgradeDialog();
                    }
                    // always redirect
                    _this.router.navigate(['/dashboard']);
                });
            }
        }
    };
    EditComponent.prototype.initKeyboardListeners = function () {
        var _this = this;
        // Tool switching
        Mousetrap.bind('1', function () { return _this.handleSelectTool(ToolEnum.Select); });
        Mousetrap.bind('2', function () { return _this.handleSelectTool(ToolEnum.Hide); });
        Mousetrap.bind('3', function () { return _this.handleSelectTool(ToolEnum.Label); });
        Mousetrap.bind('4', function () { return _this.handleSelectTool(ToolEnum.Paint); });
        Mousetrap.bind('5', function () { return _this.handleSelectTool(ToolEnum.Position); });
        // Column toggles
        Mousetrap.bind('meta+,', function (event) {
            event.preventDefault();
            _this.showColumn('left');
        });
        Mousetrap.bind('meta+.', function (event) {
            event.preventDefault();
            _this.showColumn('right');
        });
        Mousetrap.bind('meta+/', function (event) {
            event.preventDefault();
            _this.showColumn('header');
        });
        Mousetrap.bind('meta+m', function (event) {
            event.preventDefault();
            _this.showColumn('footer');
        });
        Mousetrap.bind('meta+z', function (event) {
            event.preventDefault();
            _this.undo();
        });
        Mousetrap.bind('meta+y', function (event) {
            event.preventDefault();
            _this.redo();
        });
        // Chapter browser
        Mousetrap.bind('.', function () { return _this.nextChapter(); });
        Mousetrap.bind(',', function () { return _this.previousChapter(); });
        // Delete
        Mousetrap.bind(['del', 'backspace'], function () { return _this.handleDelete(); });
        // Select all
        Mousetrap.bind('meta+a', function (event) {
            event.preventDefault();
            _this.handleSelectAll();
        });
    };
    EditComponent.prototype.unbindKeyboardListeners = function () {
        Mousetrap.unbind(['1', '2', '3', '4', '5', 'meta+m', 'meta+,', 'meta+.', 'meta+/', '.', ',', 'del', 'backspace', 'meta+a']);
    };
    /**
     * Handlers
     */
    EditComponent.prototype.handleChapterTitleClick = function () {
        this.openChapterContentDialog();
    };
    EditComponent.prototype.handleChapterChange = function (chapter) {
        var _this = this;
        this.store.dispatch(new SetCamera(chapter.camera.location));
        this.isAnimated = this.animationService.isChapterAnimated(chapter);
        this.viewGraph$
            .pipe(take(1), delay(1)).subscribe(function () {
            _this.resetHistory();
        });
    };
    EditComponent.prototype.handleSelectTool = function (tool) {
        this.store.dispatch(new SetActiveTool(tool));
        switch (tool) {
            case ToolEnum.Paint:
                this.store.dispatch(new SetView(EditViewEnum.Paint));
                break;
            case ToolEnum.Label:
                this.store.dispatch(new SetView(EditViewEnum.Label));
                break;
            case ToolEnum.Position:
                this.store.dispatch(new SetView(EditViewEnum.Position));
                break;
        }
    };
    EditComponent.prototype.handleToggleVisibleNodes = function (event) {
        this.store.dispatch(new ToggleVisibleNodes(event.nodes, event.visible));
        var record = this.store.selectSnapshot(EditState.getRecord);
        this.store.dispatch(new RecordChapterVisibilityState(event.nodes, event.visible, record));
        this.store.dispatch(new SetCheckedNodes([]));
    };
    EditComponent.prototype.handleShowColumnClick = function (column) {
        this.showColumn(column);
    };
    EditComponent.prototype.handleUndoClick = function () {
        this.undo();
    };
    EditComponent.prototype.handleRedoClick = function () {
        this.redo();
    };
    EditComponent.prototype.handleDelete = function () {
        var activeLabel = this.store.selectSnapshot(StoryLabelsState.getSelectedLabel);
        var selectedNodes = this.store.selectSnapshot(EngineNodesState.getCheckedNodes);
        if (activeLabel) {
            this.store.dispatch(new RemoveLabel(activeLabel));
        }
        else if (selectedNodes.length) {
            this.store.dispatch(new SetObjectVisibility(selectedNodes, false));
        }
    };
    EditComponent.prototype.handleSelectAll = function () {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var rootNodeIds = GraphUtils.getRoots(viewGraph);
        var rootNodes = this.graphService.getNodes(viewGraph, rootNodeIds);
        this.store.dispatch(new SetCheckedNodes(rootNodes));
    };
    /**
     * Dispatchers
     */
    EditComponent.prototype.loadStory = function () {
        var _a = this.store.selectSnapshot(StoryState.getIncomingStoryInfo), id = _a.id, type = _a.type;
        this.store.dispatch(new LoadStory(id, type));
    };
    EditComponent.prototype.handleNodeClick = function (node, event) {
        var tool = this.store.selectSnapshot(EngineState.getActiveTool);
        if (!node && !event.srcEvent.shiftKey) {
            this.store.dispatch(new SetCheckedNodes([]));
            return;
        }
        if (event.srcEvent.shiftKey) {
            var checked = this.store.selectSnapshot(EngineNodesState.getCheckedNodes).some(function (value) { return value.id === node.id; });
            this.store.dispatch(new CheckNode(node, !checked));
            this.store.dispatch(new SelectNode(node));
        }
        else {
            switch (tool) {
                case ToolEnum.Hide:
                    this.store.dispatch(new SetObjectVisibility([node], false));
                    break;
                case ToolEnum.Select:
                case ToolEnum.Position:
                    var checked = this.store.selectSnapshot(EngineNodesState.getCheckedNodes).some(function (value) { return value.id === node.id; });
                    (checked) ?
                        this.store.dispatch(new SetCheckedNodes([])) :
                        this.store.dispatch(new SetCheckedNodes([node]));
                    this.store.dispatch(new SelectNode(node));
                    this.store.dispatch(new ExpandNode(node));
                    break;
            }
        }
    };
    EditComponent.prototype.showColumn = function (column) {
        var show = true;
        switch (column) {
            case 'left':
                show = !this.store.selectSnapshot(EditState.getShowLeftColumn);
                break;
            case 'right':
                show = !this.store.selectSnapshot(EditState.getShowRightColumn);
                break;
            case 'header':
                show = !this.store.selectSnapshot(EditState.getShowHeader);
                break;
            case 'footer':
                show = !this.store.selectSnapshot(EditState.getShowFooter);
                break;
        }
        this.store.dispatch(new ShowColumn(column, show));
    };
    EditComponent.prototype.handleSaveBookmark = function () {
        if (this.atBookmarkLimit) {
            this.upgrade();
        }
        else {
            var bookmark = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
            var saveType = this.getBookmarkSaveType(bookmark);
            switch (saveType) {
                case 'save':
                    this.saveBookmark(bookmark)
                        .pipe(takeUntil(this.ngUnsubscribe))
                        .subscribe(function () { });
                    break;
                case 'saveAs':
                    this.saveBookmarkAs();
                    break;
            }
        }
    };
    // Save over loaded module
    EditComponent.prototype.saveModule = function () {
        this.dialogService.openSaveModuleDialog(this.id);
    };
    // #TODO: [EM] #SceneEditorTouchpoint - Assumes the destination is a bookmark
    EditComponent.prototype.saveBookmarkAs = function () {
        if (this.atBookmarkLimit) {
            return;
        }
        var title = 'Save As';
        var bookmarkTitle = this.store.selectSnapshot(StoryState.getStory).displayName;
        this.saveNewBookmarkDialog(title, bookmarkTitle)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () { });
    };
    EditComponent.prototype.publishBookmark = function () {
        var _this = this;
        if (this.atBookmarkLimit) {
            return;
        }
        var bookmark = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
        var saveType = this.getBookmarkSaveType(bookmark);
        // preview saved bookmark
        if (saveType === 'save' && bookmark) {
            if (this.isStoryDirty) { // save + preview
                this.confirmSaveDialog()
                    .pipe(flatMap(function (confirmed) { return confirmed ? _this.saveBookmark(bookmark, true) : of(bookmark); }), // save if confirmed
                takeUntil(this.ngUnsubscribe))
                    .subscribe(function (previewBookmark) {
                    _this.previewBookmark(previewBookmark);
                });
            }
            else {
                this.previewBookmark(bookmark);
            }
        }
        else if (saveType === 'saveAs') { // save, then preview
            var title = 'Save As';
            var bookmarkTitle = this.store.selectSnapshot(StoryState.getStory).displayName;
            var message = 'You must save your changes to publish your model.';
            this.saveNewBookmarkDialog(title, bookmarkTitle, message)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(function (savedBookmark) {
                if (savedBookmark) {
                    _this.previewBookmark(savedBookmark);
                }
            });
        }
    };
    EditComponent.prototype.isBookmarkEditable = function (bookmark) {
        if (!bookmark) {
            return false;
        }
        else {
            var is_owner = bookmark.is_owner, group_access = bookmark.group_access;
            return is_owner || (group_access ? group_access.some(function (access) { return access.member_edit; }) : false);
        }
    };
    EditComponent.prototype.getBookmarkSaveType = function (bookmark) {
        if (!bookmark) {
            return 'saveAs';
        }
        else {
            return this.isBookmarkEditable(bookmark) ? 'save' : 'saveAs';
        }
    };
    EditComponent.prototype.handlePreviewClick = function () {
        var bookmark = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
        if (bookmark) {
        }
    };
    EditComponent.prototype.handleSaveBookmarkSuccess = function (action) {
        var bookmark = action.bookmark, story = action.story;
        var id = bookmark.id, title = bookmark.title, type = bookmark.type;
        // set current route to updated content
        var query = "?id=" + id;
        this.location.replaceState('edit', query);
        this.snackBar.open(title + " saved to your dashboard.");
        if (story) {
            var currentIdx = this.store.selectSnapshot(StoryChaptersState.getSelectedChapterIndex);
            this.store.dispatch(new BuildStory(id, story, type, StoryLoadTypeEnum.OnDemand, currentIdx));
        }
    };
    EditComponent.prototype.handleSaveModuleSuccess = function (action) {
        this.id = this.sanitizeRouteId(action.id);
    };
    EditComponent.prototype.handleSaveBookmarkFailure = function (action) {
        this.snackBar.open("Unable to save \"" + action.bookmarkEntry.title + "\". Please try again.");
    };
    EditComponent.prototype.openBookmarkAccessDialog = function () {
        var bookmark = this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
        if (bookmark) {
            this.dialogService.openBookmarkAccessDialog(bookmark);
        }
    };
    EditComponent.prototype.openChapterContentDialog = function () {
        this.dialog.open(ContentDialogComponent, {
            width: '60vw',
            height: 'auto',
            data: {
                chapterId: this.store.selectSnapshot(StoryChaptersState.getSelectedChapterId)
            }
        });
    };
    EditComponent.prototype.undo = function () {
        this.store.dispatch(new Undo());
    };
    EditComponent.prototype.redo = function () {
        this.store.dispatch(new Redo());
    };
    EditComponent.prototype.resetHistory = function () {
        this.store.dispatch(new ResetHistory());
        this.historyService.recordViewGraphHistory();
    };
    EditComponent.prototype.upgrade = function () {
        this.dialogService.openUpgradeDialog();
    };
    EditComponent.prototype.openInSceneEditor = function () {
        var url = "https://scene-editor.biodigital.com/apps/editor/?m=" + this.id + ".json";
        window.open(url);
    };
    // Open current element in new window as widget (unsaved)
    EditComponent.prototype.openInWidget = function () {
        var root = window.location.origin;
        // tslint:disable-next-line:max-line-length
        var url = root + "/widget/?m=" + this.id + ".json&ui-info=true&ui-load-progress=false&ui-fullscreen=false&ui-zoom=false&ui-center=false&ui-camera-mode=false&ui-share=false";
        window.open(url);
    };
    // Open current element in new window as view (unsaved)
    EditComponent.prototype.openInView = function () {
        var root = window.location.origin;
        var url = root + "/view?id=" + this.id;
        window.open(url);
    };
    // Bookmark routes use appropriate ID parameters, but internal users would like the ability to paste
    // in legacy paths. This means stripping out the .json extension at time of page load and accounting
    // for that conversion later on. 
    EditComponent.prototype.sanitizeRouteId = function (id) {
        id = id.replace(/\.json$/, '');
        var query = "?id=" + id;
        this.location.replaceState('edit', query);
        return id;
    };
    EditComponent.prototype.nextChapter = function () {
        if (this.store.selectSnapshot(StoryChaptersState.getAllChaptersReady)) {
            this.store.dispatch(new NextChapter());
        }
    };
    EditComponent.prototype.previousChapter = function () {
        if (this.store.selectSnapshot(StoryChaptersState.getAllChaptersReady)) {
            this.store.dispatch(new PreviousChapter());
        }
    };
    EditComponent.prototype.confirmSaveDialog = function (canCancel) {
        return this.dialogService.openConfirmDialog({
            data: {
                titleText: 'Save Changes',
                bodyText: 'Would you like to save your changes to your model?',
                confirmText: 'Save',
                cancelText: "Don't Save",
                miscText: canCancel ? 'Cancel' : '',
                confirmColor: 'warn'
            }
        })
            .afterClosed();
    };
    EditComponent.prototype.saveBookmark = function (bookmark, notify) {
        var _this = this;
        if (notify === void 0) { notify = false; }
        // notify user
        if (notify) {
            this.snackBar.open("Saving \"" + bookmark.title + "\"...");
        }
        // save + return after success/error
        return this.store.dispatch(new SaveBookmark({ isOwner: bookmark.is_owner, id: bookmark.id, title: bookmark.title }, true))
            .pipe(flatMap(function () {
            return _this.actions
                .pipe(ofActionDispatched(SaveBookmarkSuccess, SaveBookmarkFail), first());
        }), map(function (e) {
            if (e instanceof SaveBookmarkSuccess) {
                return _this.store.selectSnapshot(BookmarksState.getSelectedBookmark);
            }
            else {
                return bookmark;
            }
        }));
    };
    EditComponent.prototype.saveNewBookmarkDialog = function (title, bookmarkTitle, message) {
        return this.dialogService
            .openSaveAsBookmarkDialog(title, bookmarkTitle, message)
            .afterClosed();
    };
    EditComponent.prototype.previewBookmark = function (bookmark) {
        this.dialog.open(PublishDialogComponent, {
            width: '90vw',
            height: 'auto',
            data: {
                bookmark: bookmark
            }
        });
    };
    __decorate([
        Select(LayoutState.getTheme),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "theme$", void 0);
    __decorate([
        Select(EditState.getView),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "view$", void 0);
    __decorate([
        Select(EngineState.getActiveTool),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "activeTool$", void 0);
    __decorate([
        Select(EditState.getShowColumns),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "showColumns$", void 0);
    __decorate([
        Select(EditState.getShowLeftColumn),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "showLeftColumn$", void 0);
    __decorate([
        Select(EditState.getShowRightColumn),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "showRightColumn$", void 0);
    __decorate([
        Select(EditState.getShowHeader),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "showHeader$", void 0);
    __decorate([
        Select(EditState.getShowFooter),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "showFooter$", void 0);
    __decorate([
        Select(EditState.getRecord),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "record$", void 0);
    __decorate([
        Select(EngineState.getReady),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "engineReady$", void 0);
    __decorate([
        Select(EngineState.getChapter),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "chapter$", void 0);
    __decorate([
        Select(EngineNodesState.getHoveredNode),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "hoveredNode$", void 0);
    __decorate([
        Select(EngineNodesState.getCheckedNodes),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "checkedNodes$", void 0);
    __decorate([
        Select(EngineState.getViewGraph),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "viewGraph$", void 0);
    __decorate([
        Select(EngineState.getAnimationPlaying),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "animationPlaying$", void 0);
    __decorate([
        Select(EngineCameraState.getStoredCamera('__copy')),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "cameraCopy$", void 0);
    __decorate([
        Select(StoryState.getStory),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "story$", void 0);
    __decorate([
        Select(StoryState.getIncomingStoryInfo),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "incoming$", void 0);
    __decorate([
        Select(StoryLabelsState.getLabels),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "labels$", void 0);
    __decorate([
        Select(StoryLabelsState.getSelectedLabel),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "selectedLabel$", void 0);
    __decorate([
        Select(StoryChaptersState.getChaptersLoaded),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "chaptersLoaded$", void 0);
    __decorate([
        Select(StoryChaptersState.getAllChaptersReady),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "allChaptersReady$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterId),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "selectedChapterId$", void 0);
    __decorate([
        Select(BookmarksState.getSelectedBookmark),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "selectedBookmark$", void 0);
    __decorate([
        Select(BookmarksState.getSaving),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "saving$", void 0);
    __decorate([
        Select(AuthState.getUserProfile),
        __metadata("design:type", Observable)
    ], EditComponent.prototype, "userProfile$", void 0);
    return EditComponent;
}());
export { EditComponent };
